import { Route, Switch } from 'react-router-dom';
import * as React from 'react';
import { useMemo } from 'react';

import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

import {
  DATA_FIELD_LIST_PATH,
  DATA_FIELD_PATH,
  DATA_SEARCH_RESULT_PATH,
  DATASET_LIST_PATH,
  MAIN_DATA_PATH,
  OLD_DATA_FIELD_PATH,
  SINGLE_DATASET_PATH,
} from './dataExplorerRouterPaths';
import DataField from './DataField/DataField';
import DatasetsList from './DatasetsList';
import DataMain from './MainDataPage/MainDataPage';
import Dataset from './Dataset/Dataset';

import './DataTableCommon/DataTableCommon.scss';
import AllFieldsList from './AllFieldsList';
import { useResetScroll } from '../../shared/hooks/useResetScroll';
import DataSearchResult from './SearchResult/SearchResult';
import { dataExplorerHistoryContext } from './dataExplorerHistoryContext';
import classcat from 'classcat';

export type DataRoutesProps = { path?: string; className?: string; resetScrollCallback?(): void; scrollElement?: HTMLElement };

const DataRoutes = ({ path = '', className, resetScrollCallback }: DataRoutesProps) => {
  const contextValue = useMemo(() => ({ path }), [path]);

  useResetScroll(resetScrollCallback);
  return (
    <ErrorBoundary showUI={true} isNotFullScreen={true}>
      <dataExplorerHistoryContext.Provider value={contextValue}>
        <section className={classcat(['data__page', className])}>
          <div className="data__container">
            <Switch>
              <Route exact={true} path={`${path}${MAIN_DATA_PATH}`}>
                <DataMain />
              </Route>
              <Route path={`${path}${DATASET_LIST_PATH}`} exact={true} component={DatasetsList} />
              <Route path={`${path}${DATA_FIELD_PATH}`} component={DataField} />

              <Route path={`${path}${DATA_FIELD_LIST_PATH}`} component={AllFieldsList} />
              <Route path={`${path}${SINGLE_DATASET_PATH}`} component={Dataset} exact={true} />
              <Route path={`${path}${OLD_DATA_FIELD_PATH}`} component={DataField} />

              <Route path={`${path}${DATA_SEARCH_RESULT_PATH}`} component={DataSearchResult} />
            </Switch>
          </div>
        </section>
      </dataExplorerHistoryContext.Provider>
    </ErrorBoundary>
  );
};

export default DataRoutes;
